<div class="checkbox-container">
  <div class="input-container" [class.error]="errorMessage()" [formGroup]="form">
    <input
      type="checkbox"
      [id]="name"
      [formControlName]="controlName"
      (keydown.enter)="this.input.nativeElement.click()"
      #checkbox
    />
    <label [for]="name"><ng-content></ng-content></label>
  </div>
  @if (errorMessage(); as message) {
    <span class="error-message">{{ message }}</span>
  }
</div>
